import {Link} from 'gatsby';
import React from 'react';
import slugify from '../utils/slugify';
import {getCurrentLocale} from "./getCurrentLocale";

import sidebarStyles from '../components/sidebar/sidebar.module.scss'


export const createLinkDocs = ({isActive, item, location}) => {
    let locale = getCurrentLocale(location.pathname);
    return (
        <Link className={isActive ? sidebarStyles.sidebarLinkActive : sidebarStyles.sidebarLink}
              to={`/${locale}/${slugify(item.id)}`}>
            {item.title}
        </Link>
    );
};